import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'staff/admin/banners',
    pathMatch: 'full',
  },
  {
    path: 'staff',
    loadComponent: () =>
      import('./layouts/staff/staff-layout.component').then((m) => m.StaffLayoutComponent),
    children: [
      {
        path: '',
        loadChildren: () => import('./features/staff/staff.routes').then((m) => m.staffRoutes),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'staff/admin/banners',
  },
];
